import { use_slice_workspace, use_slice_workspace_billing } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { get_sorted_current_workspace_users } from '@/utils/utils_workspace';
import { DTOWorkspaceCreditTransaction } from '@shared/dto/+workspace/workspace_credit_transaction/dto_workspace_credit_transaction';
import { format_compact_number, format_number_with_spaces } from '@shared/utils/utils_number';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EMonth } from '../../credits_transactions/_base/EMonth';
import { WSTableCreditsStatisticsCell } from './WSTableCreditsStatisticsCell';

interface Props {
  month: string;
  year: number;
  is_coins: boolean;
}

export function WSTableCreditsStatisticsRow({ month, year, is_coins }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { workspace_current } = use_slice_workspace(['workspace_current']);
  const { credit_transactions_map } = use_slice_workspace_billing(['credit_transactions_map']);

  const [isHovered, setIsHovered] = useState(false);
  /*
   * METHODS
   */

  function filter_credits(transaction: DTOWorkspaceCreditTransaction) {
    if (transaction.workspace_id != workspace_current._id) return false;
    if (!transaction.created_at) debugger;

    const date = new Date(transaction.created_at);
    const credit_month = date.getMonth(); // 0 - 11
    const credit_year = date.getFullYear();

    switch (month) {
      case EMonth.YEAR:
        return credit_year === year;
      case EMonth.JANUARY:
        return credit_month === 0 && credit_year === year;
      case EMonth.FEBRUARY:
        return credit_month === 1 && credit_year === year;
      case EMonth.MARCH:
        return credit_month === 2 && credit_year === year;
      case EMonth.APRIL:
        return credit_month === 3 && credit_year === year;
      case EMonth.MAY:
        return credit_month === 4 && credit_year === year;
      case EMonth.JUNE:
        return credit_month === 5 && credit_year === year;
      case EMonth.JULY:
        return credit_month === 6 && credit_year === year;
      case EMonth.AUGUST:
        return credit_month === 7 && credit_year === year;
      case EMonth.SEPTEMBER:
        return credit_month === 8 && credit_year === year;
      case EMonth.OCTOBER:
        return credit_month === 9 && credit_year === year;
      case EMonth.NOVEMBER:
        return credit_month === 10 && credit_year === year;
      case EMonth.DECEMBER:
        return credit_month === 11 && credit_year === year;
      default:
        return false;
    }
  }

  /*
   * RENDER
   */

  /*
   * RENDERS
   */

  function render_cell_all_time(total_credits_in_month: number) {
    let value = isHovered ? format_number_with_spaces(total_credits_in_month) : format_compact_number(total_credits_in_month);

    if (total_credits_in_month == 0) {
      // do nothing
    } else if (is_coins) {
      value = '100%';
    }

    return (
      <span
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        key={`${month}-total`}
        className={`${md('min-w-[40px] text-[12px]', 'min-w-[100px] h-[50px]')} border-r border-component-item border-dashed flex items-center justify-center
      
      
      `}
      >
        <span className={`${total_credits_in_month == 0 ? 'opacity-50' : ''}`}>{value}</span>
      </span>
    );
  }

  function render_cells(isHovered: boolean) {
    const workspace_credits = Array.from(credit_transactions_map.values()).flatMap(inner_map => Array.from(inner_map.values()));

    const credits_per_month = workspace_credits.filter(filter_credits);

    const total_credits_in_month = credits_per_month.reduce((acc, transaction) => acc + transaction.value, 0);

    const users = get_sorted_current_workspace_users();

    const users_cells = users.map(user => {
      return (
        <WSTableCreditsStatisticsCell
          key={`WSTableCreditsStatisticsRow_${user._id}`}
          user={user}
          total_credits_in_month={total_credits_in_month}
          credits_per_month={credits_per_month}
          is_coins={is_coins}
        />
      );
    });

    return (
      <>
        {render_cell_all_time(total_credits_in_month)}
        {users_cells}
      </>
    );
  }

  /*
   * HTML
   */

  return (
    <>
      <div className={`${md('px-2 justify-start gap-2', ' px-5 justify-start')} w-full min-h-[50px] flex flex-row items-center`}>
        <span className={`${md('min-w-[130px] text-[9px]', 'min-w-[220px]')} text-left`}>
          <span className="text-center w-[38px] !block">
            {month === EMonth.YEAR
              ? t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_statistic_monthly.row[month])
              : t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_statistic_monthly.row[month]).substring(0, 3)}
          </span>
        </span>
        {render_cells(isHovered)}
      </div>
      {month === EMonth.YEAR && <div className="w-full border-t border-component-item border-dashed" />}
    </>
  );
}
